import { eventEmitter } from "../usecase/eventEmitter";
export class Presenter {
    state;
    subscribers = new Set();
    stateChangeHandler;
    constructor() {
        this.stateChangeHandler = (newState) => {
            if (typeof this.createModel !== 'function') {
                setTimeout(() => this.stateChangeHandler(newState), 0);
                return;
            }
            const newModel = this.createModel(newState.getState());
            this.state = newModel;
            this.notifySubscribers();
        };
        eventEmitter.registerForStateChange(this.stateChangeHandler);
    }
    subscribe(listener) {
        this.subscribers.add(listener);
        listener(this.state);
    }
    unsubscribe(listener) {
        this.subscribers.delete(listener);
    }
    notifySubscribers() {
        this.subscribers.forEach((listener) => listener(this.state));
    }
    destroy() {
        eventEmitter.unregisterFromStateChange(this.stateChangeHandler);
        this.subscribers.clear();
    }
}
